import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import DashboardLayout from './pages/DashboardLayout';
import Overview from './pages/Overview';
import Attendance from './pages/Attendance';
import DailyAttendance from './pages/DailyAttendance';
import Disciplinary from './pages/Disciplinary';
import JobApplications from './pages/JobApplications';
import JobApplicationPublic from './pages/JobApplicationPublic';
import Settings from './pages/Settings';
import UserManagement from './pages/UserManagement';
import RolePermissions from './pages/RolePermissions';
import GeneralDocuments from './pages/GeneralDocuments';
import ProtectedRoute from './components/ProtectedRoute';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/apply" element={<JobApplicationPublic />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Overview />} />
            <Route path="attendance" element={<Attendance />} />
            <Route
              path="daily-attendance"
              element={
                <ProtectedRoute allowedRoles={['admin', 'board_member', 'teacher']}>
                  <DailyAttendance />
                </ProtectedRoute>
              }
            />
            <Route path="disciplinary" element={<Disciplinary />} />
            <Route path="jobs" element={<JobApplications />} />
            <Route
              path="users"
              element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="permissions"
              element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <RolePermissions />
                </ProtectedRoute>
              }
            />
            <Route path="documents" element={<GeneralDocuments />} />
            <Route
              path="settings"
              element={<Settings />}
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
